import { render, staticRenderFns } from "./FileSystemDetail.vue?vue&type=template&id=ad697470"
import script from "./FileSystemDetail.vue?vue&type=script&lang=js"
export * from "./FileSystemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports